/**
* @prop--uic-segmented-control-active-item-z-index: z-index of active items.
* @prop--uic-segmented-control-active-item-z-index: z-index of selected items.
* @prop --uic-segmented-control-min-width: min width of the buttons.
*/

uic-segmented-control {
  display: inline-flex;
  flex-wrap: wrap;

  // value attr selector does not work with data-binding on buttons
  > [value],
  uic-button {
    padding-left: 0;
    padding-right: 0;

    &:not(:first-of-type) {
      margin-left: -1px;
    }

    // modifiers
    &:active,
    &:focus,
    &:hover {
      z-index: var(--uic-segmented-control-active-item-z-index);
    }

    &[selected] {
      z-index: var(--uic-segmented-control-selected-item-z-index);
    }

    &::before {
      display: none;
    }

    > button {
      min-width: var(--uic-segmented-control-min-width, 64px);
    }
  }
}
